import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import GroupRoutes from './GroupRoutes';
import Home from '../pages/Home';
import Login from '../pages/Login';

class Main extends Component {
  render() {
    return (
      <div>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/channel/:channelId/groups" component={GroupRoutes} />
          <Route path="/login" component={Login} />
          <Route component={Home} />
        </Switch>
      </div>
    );
  }
}

export default Main;
